<template>
  <a-spin :tip="spinningText" :spinning="spinning">
    <div style="width: 1200px; margin: 0px auto;  min-height: calc(100vh - 240px);" v-if="!searching">
      <!--      <div style="width: 900px;margin: 0 auto;margin-top: 50px;">-->
      <!--        <input v-model="keyword" type="text" autocomplete="off" placeholder="企业法定全称" maxlength="50"-->
      <!--               style="width: 70%; -webkit-appearance: none;-->
      <!--    background-color: #fff;-->
      <!--    border-radius: 4px 0 0 4px;-->
      <!--    border: 1px solid #dcdfe6;-->
      <!--    box-sizing: border-box;-->
      <!--    color: #606266;-->
      <!--    height: 42px;-->
      <!--    line-height: 40px;-->
      <!--    outline: 0;-->
      <!--    padding: 0 15px;-->
      <!--    transition: border-color .2s cubic-bezier(.645,.045,.355,1);-->
      <!--    width: 80%;-->
      <!--    background-image: none;-->
      <!--    font-size: 16px;-->
      <!--    font-weight: 600;">-->
      <!--        <span style="    cursor: pointer;-->
      <!--    width: 20%;-->
      <!--    color: #fff;-->
      <!--    font-size: 20px;-->
      <!--    background-color: #014298;-->
      <!--    padding: 7px 40px 9px 40px;" @click="searchQuery">查 询</span>-->
      <!--      </div>-->
      <!--      <div style="width: 900px;margin: 0 auto;margin-top: 50px">-->
      <!--        <h1>温馨提示</h1>-->
      <!--        <p>1、请使用企业法定全称查询</p>-->
      <!--        <p>2、生成完整数据报告按29.90元/次计费（数据报告可截图、下载）</p>-->
      <!--        <p>3、使用过程中有问题请咨询客服，邮箱：kefu@axinyong.com.cn</p>-->
      <!--      </div>-->


      <a-modal
          title="充值提醒"
          :visible="visible"
          :footer="false"
          @cancel="handleCancel">
        <p>余额不足，是否<a style="color: #1977f5" @click="toCz">前往充值？</a></p>
      </a-modal>
    </div>

    <div id="report-main" style="width: 900px;margin: 0 auto;" v-if="searching">
      <!--头部工具栏-->
      <div id="report-tool" style="height:80px;line-height: 80px;text-align: right;">
       <span style="cursor: pointer;
    width: 15%;
    color: #fff;
    font-size: 20px;
    background-color: #014298;
    padding: 7px 40px 9px 40px;margin-left: 10px" @click="downLoad">下载报告</span>
        <span style="    cursor: pointer;
    width: 15%;
    color: #111111;
    font-size: 20px;
    background-color: #eeeeee;
    padding: 7px 40px 9px 40px;margin-left: 10px" @click="back">返回查询</span>
      </div>

      <a-divider/>


      <!--报告主体部分-->
      <div id="report-data">
        <div id="creditLevel" style="border-radius: 12px;box-shadow: 0 6px 18px #00000014;border: 1px solid #f0f0f0;">
          <div style="margin: 100px;">
            <div style="text-align: center;">
              <span
                  style="color: #004298;font-size: 45px; position: relative; text-align: center;">特殊资产风险等级</span>
            </div>
            <div style="text-align: center;font-weight: bold;margin-top: 50px;font-size: 25px">
              <span>{{ this.keyword }} </span>
            </div>
            <div style="text-align: left;font-size: 15px;margin-top: 20px;">
              <div>通过多维数据+AI+区块链+大模型对该主体进行价值判断，综合评价为:</div>
              <div style="text-align: center;font-size: 80px;font-weight: bold;color: #004298">
                {{ this.evaluate.evaluateInfo.riskLevel }}
              </div>
            </div>
            <div style="margin-top: 40px;font-size: 16px;">
              <span>报告编号：<span style=" font-weight: bold;">{{ this.evaluate.reportId }} </span> </span>
            </div>
            <div style="font-size: 16px;margin-top: 10px;">
              <span>生成时间：<span style=" font-weight: bold;">{{ this.evaluate.dateTime }} </span> </span>
            </div>
            <div style="font-size: 13px;margin-top: 30px;">
              <span>特殊资产风险等级报告说明：</span>
            </div>
            <div>
              <ul class="agreement-list">
                <li>1、特殊资产风险等级从高到低分为A、B、C、D四个等级。A级(可能回收率80%以上)、B级(可能回收率50%-80%)、 C级(可能回收率20%-50%)、 D级(可能回收率低于20%)。</li>
                <li>2、任何机构或个人在使用本系统所提供的服务以及下载相关评价报告的过程中，必须遵循法律法规、规章制度、规范性文件及政策要求的规定。不得利用本评价报告从事任何影响公平竞争、侵犯商业秘密、诋毁恐吓等违法犯罪行为。否则独自承担由此而产生的一切法律责任。</li>
                <li>3、本评价报告是通过多维数据+AI+区块链+大模型对特殊资产进行价值判断，通过定性+定量分析，自动识别资产风险等级，量化特殊资产潜在损失风险，为处置、投资决策提供参考依据。</li>
                <li>4、本评价报告结果仅供参考，不作为任何决策依据。对依据本报告做出的任何决定、决策，我方均不承担经济损失和法律责任。 </li>
                <li>5、下载用户未经书面许可，不得以任何形式将本报告全部或部分内容提供、复制、摘录、编辑、转载、披露和发送给任何第三方。</li>
                <li>6、不保证本评价报告内容的真实性、完整性、准确性和及时性，报告内容仅供参考。本平台和数据合作方不承担任何责任，也不享受使用此报告可能给用户或他人带来的任何利益。 </li>
              </ul>

            </div>
            <div class="pdf-footer">
              <span style="margin-right: 20px;">北京全民普惠信用管理有限公司</span>
              <span style="">特资信大模型·特殊资产价值智评系统</span>
            </div>
          </div>
        </div>

      </div>

      <a-divider/>
    </div>
  </a-spin>
</template>

<script>

import {getAction, downFile, postActionTimeout} from "@/api/manage";
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  name: "Report",
  data() {
    return {
      keyword: '',
      idCard: '',
      overdueDate: '',
      defaultAmount: '',
      city: '',
      hasCollateral: false,
      industry: '',
      spinning: false,
      searching: false,
      searchKey: '',
      url: {
        queryUrl: '/search/query',
        getBalanceUrl: '/pay/balance'
      },
      balance: 0,
      visible: false,
      dateTime: new Date(),
      reportId: '0',
      scoreInfo: {},
      spinningText: '报告加载中...',
      queryType: 0,
      evaluate:{}
    }
  },
  created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.$router.push('/login');
    }
    if (this.$route.params.queryType == 0 || this.$route.params.queryType == 1) {
      this.keyword = this.$route.params.queryType == 0 ? this.$route.params.entName : this.$route.params.name;
      this.idCard = this.$route.params.idCard;
      this.overdueDate = this.$route.params.overdueDate
      this.defaultAmount = this.$route.params.defaultAmount
      this.city = this.$route.params.city
      this.hasCollateral = this.$route.params.hasCollateral == 1 ? true : false
      this.industry = this.$route.params.industry
      this.queryType = this.$route.params.queryType
      this.getData();
    } else {
      this.$router.push('/');
    }

  },
  methods: {
    getBalance() {
      let param = {
        name: this.$route.params.name,
        entName: this.$route.params.entName,
        idCard: this.idCard,
        overdueDate: this.overdueDate,
        defaultAmount: this.defaultAmount,
        city: this.city,
        hasCollateral: this.hasCollateral,
        industry: this.industry,
        queryType: this.queryType
      }
      getAction(this.url.getBalanceUrl).then(res => {
        if (res.success) {
          this.balance = res.data.balance;
          if (res.data.balance < 29.9) {
            this.$router.push({name: 'pay', params: param})
          }
        }
      })
    },
    handleCancel() {
      this.visible = false;
    },
    toCz() {
      this.$router.push('/pay')
      this.visible = false;
    },
    getData() {
      // if (!this.keyword) {
      //   this.searching=false;
      //   this.$message.warning('请输入企业法定全称！')
      //   return;
      // }
      // if (this.keyword.length<4) {
      //   this.searching=false;
      //   this.$message.warning('请输入正确的企业法定全称！')
      //   return;
      // }
      this.getBalance();
      this.spinning = true;
      this.spinningText = '报告加载中...';
      this.searchKey = this.keyword;
      let param = {
        name: this.keyword,
        idCard: this.idCard,
        overdueDate: this.overdueDate,
        defaultAmount: this.defaultAmount,
        city: this.city,
        hasCollateral: this.hasCollateral,
        industry: this.industry,
        queryType: this.queryType
      }
      postActionTimeout(this.url.queryUrl, param, 90000).then(res => {
        if (res.success) {
          this.searching = true;
          this.spinning = false;
          this.evaluate = res.data;
        } else {
          this.spinning = false;
          if(res.code==1007){
            this.$message.error("查询报告需花费29.90元，您的余额不足！")
          }else{
            this.$message.error(res.message)
          }

        }
      })
    },
    fk() {
      this.$router.push({name: 'search', params: {keyword: this.keyword}});
    },
    downLoad() {

      this.spinning = true;
      this.spinningText = '报告下载中...';
      downFile('/pdf/downCreditReport', {reportId: this.evaluate.reportId}).then(data => {
        if (!data) {
          this.spinning = false;
          this.$message.warning("文件下载失败")
          return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', this.keyword + '-特殊资产风险等级报告.pdf')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      })
    },
    searchQuery() {
      this.getData()
    },
    back() {
      this.spinning = false;
      this.dateTime = '';
      this.reportId = '';
      this.searching = false;
      this.keyword = '';
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.pdf {
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
}

td {
  padding: 20px;
}

#report-data {
  color: #111111 !important;
}

#creditLevel {

}

.dataTitle {
  display: table;
  width: 100%;
  background-color: #aad2f7;
}

.dataTitle span {
  line-height: 40px;
  display: table-cell;
  width: 33.33%;
  text-align: center;
  font-weight: bold;
  border: 1px solid #e9edf4;
}

.dataContent {
  display: table;
  width: 100%;
  background-color: white;
}

.dataContent span {
  line-height: 40px;
  display: table-cell;
  width: 33.33%;
  text-align: center;
  font-size: 13px;
  border: 1px solid #e9edf4;
}

.dataContentDesc {
  font-size: 13px;
  padding: 0px 40px;
  width: 100%;

}


.dataContentDesc span {
  width: 80%;
  line-height: 30px;
}

.agreement-list {
  margin: 10px 0px;
}

.agreement-list li {
  position: relative;
  padding-left: 15px;
  line-height: 25px;
  font-size: 12px;
  color: #444;
}

.dimension-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.dimension-cards .dimension-card {
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dimension-name {
  font-size: 14px;
  margin-bottom: 8px;
}

.dimension-score {
  font-size: 12px;
  margin-bottom: 8px;
}

.dimension-level {
  font-size: 14px;
  margin-bottom: 8px;
}
.pdf-footer{
  margin-top: 100px;
  text-align: right;
}
.pdf-footer span{
  display: block;
}
</style>
